import Alpine from "alpinejs";

Alpine.data("productResources", (currentCompanyId, productId) => ({
  loading: false,
  resources: [],
  currentCompanyId: currentCompanyId,
  productId: productId,
  init() {
    if (!this.productId) {
      return;
    }

    this.loading = true;
    this.getResources().finally(() => {
      this.loading = false;
    });
  },
  normalizeResource(resource) {
    return {
      title: resource?.title || "",
      file: resource?.file || resource?.file_upload?.value?.url || null,
    };
  },
  async getResources() {
    try {
      const apiUrl = new URL("https://shopify-api.clearwebserver.co.uk/rozone/");
      apiUrl.searchParams.set("product", String(this.productId));

      if (this.currentCompanyId) {
        apiUrl.searchParams.set("company", String(this.currentCompanyId));
      }

      const response = await fetch(apiUrl.toString());

      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}`);
      }

      const data = await response.json();
      this.resources = (Array.isArray(data) ? data : [])
        .map((resource) => this.normalizeResource(resource))
        .filter((resource) => resource.title && resource.file);
    } catch (error) {
      console.error("Error fetching product resources:", error);
      this.resources = [];
    }
  },
}));
